import { BlogSection } from '@/types/blog';

export const werteSection: BlogSection = {
  id: 'werte',
  title: 'Mit Geld in Einklang mit deinen Werten handeln',
  content: `
    <h3>6. Mit Geld in Einklang mit deinen Werten handeln</h3>
    
    <p>
      Studien der positiven Psychologie zeigen: Menschen, die ihr Geld in Einklang mit ihren Werten nutzen – sei es 
      für Erlebnisse, soziale Projekte oder persönliche Weiterentwicklung – empfinden mehr Zufriedenheit 
      (Dunn et al., 2011). Frage dich:
    </p>
    
    <ul class="list-disc pl-5 my-4">
      <li>Welche finanziellen Entscheidungen fühlen sich für mich wirklich richtig an?</li>
      <li>Wie kann ich mein Geld bewusster für das einsetzen, was mir langfristig wichtig ist?</li>
    </ul>
    
    <div class="my-6 bg-joerg-50 p-5 rounded-lg border border-joerg-100">
      <h4 class="text-joerg-800 font-medium mb-3">Wertebasierte Finanzplanung:</h4>
      <ol class="list-decimal pl-5">
        <li class="mb-2">Identifiziere deine 3-5 wichtigsten Werte (z.B. Familie, Freiheit, Gesundheit, Wachstum, Sicherheit)</li>
        <li class="mb-2">Prüfe deine aktuellen Ausgaben: Wie viel Prozent deines Geldes fließt in jeden dieser Wertebereiche?</li>
        <li class="mb-2">Gibt es Diskrepanzen zwischen dem, was du sagst, dass es dir wichtig ist, und dem, wofür du tatsächlich Geld ausgibst?</li>
        <li>Plane dein Budget neu, sodass es deine wirklichen Prioritäten widerspiegelt</li>
      </ol>
    </div>
  `
};